var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col",style:({
    '--padding': _vm.padding,
    '--width': _vm.width,
    '--md-width': _vm.mdWidth || _vm.width,
    '--sm-width': _vm.smWidth || _vm.mdWidth || _vm.width,
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }